import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { smoothScrollToElement } from '../../../shared/scroll';
import { toggleSection, onClickAccHandler, sectionIsOpen, accScroll } from '../../../shared/page-accordion';
import { Suspense, lazy } from 'preact/compat';
const PromoMessage = lazy(
    () => import(/* webpackChunkName: "promo-message" */ '../../../app/components/promo-message')
);

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        this.shown = props.route && props.route.match(/glossary/);

        this.open_section = this.getOpenSection(props);

        let open_chapters = [];

        if (props.route.match(/glossary/)) {
            open_chapters.push(props.route);
        }

        this.state = { open_chapters: open_chapters };
    }

    componentDidMount() {
        if (this.props.route.match(/glossary/)) {
            const scrollTo = this.props.route == 'glossary' ? this.props.selector : `#${this.props.route}`;
            smoothScrollToElement(document.querySelector(scrollTo));
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        this.shown = nextProps.route.match(/glossary/);
        this.open_section = this.getOpenSection(nextProps);

        if (nextProps.route != this.props.route) {
            if (this.shown) {
                const state = this.state;
                state.open_chapters = toggleSection(this.state.open_chapters, nextProps.route);
                this.setState(state);
            }

            return true;
        }

        if (nextState != this.state) {
            return true;
        }

        return false;
    }

    componentDidUpdate() {
        if (this.props.route === 'glossary') {
            accScroll('glossary', 300);
        }
    }

    render() {
        return (
            <glossary id='glossary' className={this.shown ? 'is-shown' : null}>
                {this.renderBlocks()}
                {this.renderPromoMessage()}
            </glossary>
        );
    }

    renderBlocks = () => {
        const blocks = this.props.report.product.display.sections.slice(-1)[0].block;

        return blocks.map(block => {
            const id = block.content.title.match(/Houses/)
                ? 'houses-meaning'
                : block.content.title.toLowerCase().replace(/ /g, '-');

            return (
                <section id={`glossary-${id}`} className={this.open_section.match(`glossary-${id}`) ? 'is-shown' : ''}>
                    <h1>{block.content.title}</h1>
                    {this.renderBlockBody(block.content.body)}
                    {this.renderBlockDefinitions(block.content.definitions, `glossary-${id}`)}
                </section>
            );
        });
    }

    renderBlockBody = (body) => {
        if (Array.isArray(body)) {
            return body.map(p => (<p>{p}</p>));
        }

        return null;
    }

    renderBlockDefinitions = (definitions, id) => {
        if (Array.isArray(definitions)) {
            return definitions.map((definition, i) => {
                const chapter = `${id}-chapter-${i}`;
                const [title, subtitle] = definition.title.split(':');

                return (
                    <div
                        className={`report-item ${sectionIsOpen(this.state.open_chapters, chapter)
                            ? 'is-open'
                            : 'is-closed'
                        }`}
                        id={chapter}
                    >
                        <a className='report-item-tab' onClick={(e) => this.goTo(e, chapter)}>
                            <h2>
                                <span className='has-padding-15-right'>{title}</span>
                                <span className='has-text-boulder has-text-size-20 is-hidden-mobile'>
                                    {subtitle.replace(/°/g, ' degrees')}
                                </span>
                            </h2>
                            <h4 className='has-text-boulder is-visible-mobile is-hidden-print'>
                                {subtitle.replace(/°/g, ' degrees')}
                            </h4>
                        </a>
                        <div className='report-item-content'>
                            {this.renderBlockBody(definition.body)}
                        </div>
                    </div>
                );
            });
        }

        return null;
    }

    renderPromoMessage = () => {
        let tags = 'glossary';

        if (this.props.selector == 'astrology-compatibility-report') {
            return null;
        } else if (this.props.selector == 'essential-birth-report') {
            tags = this.props.is_sample ? `${tags},ebrsample` : `${tags},ebr`;
        } else if (this.props.selector == 'ultimate-love-report') {
            if (this.props.upc) {
                if (this.props.upc.match(/^30-day/)) {
                    tags = this.props.is_sample ? `${tags},30lfsample` : `${tags},30lf`;
                } else {
                    tags = this.props.is_sample ? `${tags},uprsample` : `${tags},upr`;
                }
            } else {
                tags = this.props.is_sample ? `${tags},ulrsample` : `${tags},ulr`;
            }
        }

        return (
            <p className='has-text-center has-margin-20-top has-padding-15-left has-padding-15-right'>
                <Suspense fallback={<div className='skeleton' />}>
                    <PromoMessage placement='in-product' tags={tags} />
                </Suspense>
            </p>
        );
    }

    goTo = (e, chapter) => {
        e.preventDefault();
        let clickResult = onClickAccHandler(this.state.open_chapters, chapter, this.props.route);
        const state = this.state;
        state.open_chapters = clickResult[0];
        this.setState(state);

        if (clickResult[1] == true) {
            this.props.routeTo(chapter);
        }

        if (clickResult[2] == true) {
            accScroll(chapter, 400);
        }
    }

    getOpenSection = (props) => {
        return props.route && props.route == 'glossary'
            ? `glossary-${props.report.product.display.sections.slice(-1)[0]
                .block[0].content.title.toLowerCase().replace(/ /g, '-')}`
            : props.route;
    }
}

const mapStateToProps = (state) => ({
    report: state.report,
    route: state.route,
    is_sample: state.report && state.report.product_code && state.report.product_code.match(/sample/),
});

const mapDispatchToProps = (dispatch) => ({
    routeTo: (payload) => dispatch({ type: 'route:to', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
